import tmsApi from '../api/tmsApi';
import helper from './helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    gps_devices: [],
    query: {
      company_id: null,
      vehicle_id: null,
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.gps_devices.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.gps_devices.push(data);
    },
    CLEAR_QUERY({ query }) {
      query.company_id = null;
      query.vehicle_id = null;
    },
    SET_COMPANY_ID(state, id) {
      state.query.company_id = id;
    },
    SET_VEHICLE_ID(state, id) {
      state.query.vehicle_id = id;
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
  },
  getters: {
    gps_devices(state) {
      return state.gps_devices;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const vehicleId = createInputParam(state.query, 'vehicle_id', false);
      const query = `
      {
        gps_devices(
          ${companyId}
          ${vehicleId}
        ) {
            id
            number
            type
            vehicle {
              id
              reg_no
            }
            company {
              id
              name
            }
            gps_info {
              longitude
              latitude
            }
            metadata
            created_at
        }
      }
    `;
      commit('CLEAR_DATA');
      return api(query, 'gps_devices').then(({ data }) => {
        const { gps_devices } = data;
        gps_devices.forEach((gpsDevice) => {
          commit('ADD_DATA_ON_LIST', gpsDevice);
        }, this);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token);
      const query = `
        {
          gps_device(id: ${state.detailDataId}) {
            id
            number
            type
            vehicle {
              id
              reg_no
            }
            company {
              id
              name
            }
            gps_info {
              longitude
              latitude
            }
            metadata
            created_at
          }
        }
      `;
      return api(query, 'gps_device').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.gps_device);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    CREATE_DATA({ state, rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);
      const { query: { vehicle_id: vehicleId, company_id: companyId } } = state;

      const number = createInputParam(payloads, 'number');
      const type = createInputParam(payloads, 'type', false);
      const mutation = `mutation {
        gps_device: create_gps_device(input: {
          ${number}
          ${type}
          vehicle_id: ${vehicleId}
          company_id: ${companyId}
        }) {
          id
        }
      }`;
      return api(mutation, 'create_gps_device').then((data) => {
        const { gps_device: gpsDevice } = data;
        return gpsDevice;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    UPDATE_DATA({ state, rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);
      const { query: { vehicle_id: vehicleId, company_id: companyId } } = state;

      const id = createInputParam(payloads, 'id', false);
      const number = createInputParam(payloads, 'number');
      const type = createInputParam(payloads, 'type', false);
      const mutation = `mutation {
        gps_device: update_gps_device(${id} input: {
          ${number}
          ${type}
          vehicle_id: ${vehicleId}
          company_id: ${companyId}
        }) {
          id
        }
      }`;
      return api(mutation, 'update_gps_device').then((data) => {
        const { gps_device: gpsDevice } = data;
        return gpsDevice;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    DELETE_DATA({ rootState, commit }, id) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_gps_device(id: ${id})
      }`;
      return api(mutation, 'delete_gps_device').then(({ data }) => {
        const { deleted } = data;
        return deleted;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    SET_DEFAULT({ rootState, commit }, id) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        updated: set_default(id: ${id})
      }`;
      return api(mutation, 'set_default').then(({ data }) => {
        const { updated } = data;
        return updated;
      }).catch(() => {
        commit('ADD_ERROR', 'SET_DEFAULT');
      });
    },
    REMOVE_DEFAULT({ rootState, commit }, id) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        removed: remove_default(id: ${id})
      }`;
      return api(mutation, 'set_default').then(({ data }) => {
        const { removed } = data;
        return removed;
      }).catch(() => {
        commit('ADD_ERROR', 'REMOVE_DEFAULT');
      });
    },
    GET_GPS_POSITIONS({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token);
      const { start_date, end_date, number } = payloads;

      const query = `
      {
        positions: gps_positions(
            number: "${number}",
            start_date: "${start_date}",
            end_date: "${end_date}"
          ) {
          id
          alat
          along
          adevid
          roadname
          ldatetime
          adatetime
        }
      }`;

      return api(query, 'get_gps_positions')
        .then(({ data }) => data.positions)
        .catch(() => {
          commit('ADD_ERROR', 'GET_GPS_POSITIONS');
        });
    },
    GET_GPS_REALTIME({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token);
      const { number } = payloads;

      const query = `
      {
        position: gps_realtime_position(
            number: "${number}"
          ) {
          id
          alat
          along
          adevid
          roadname
          ldatetime
          adatetime
        }
      }`;

      return api(query, 'gps_realtime_position')
        .then(({ data }) => data.position)
        .catch(() => {
          commit('ADD_ERROR', 'GET_GPS_REALTIME');
        });
    },
    GET_GPS_POSITIONS_BY_DEVICEID({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.get_positions_by_deviceid;
      return api(token, payloads)
        .then(({ data }) => data)
        .catch(() => {
          commit('ADD_ERROR', 'GET_GPS_POSITIONS_BY_DEVICEID');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/gps_devices.js